<template>
  <div class="time-picker indent-1">
    <!---->
    <label for="target-time">time</label>
    <time-input :currentTime="value" :frameRate="frameRate" @timeChange="(time) => onNewTime(time)"/>
    <a v-if="controls.start" class="icon-button" v-tooltip.bottom-center="'set the time to the start of the selected scene'" href="#" v-on:click.prevent="onStartTime">
      <i class="material-icons">skip_previous</i>
    </a>
    <a v-if="controls.end" class="icon-button" v-tooltip.bottom-center="'set the time to the end of the selected scene'"  href="#" v-on:click.prevent="onEndTime">
      <i class="material-icons">skip_next</i>
    </a>
    <a v-if="!showWaypointNavigator" class="icon-button" v-tooltip.bottom-center="'Show waypoint\'s time picker'"  href="#" v-on:click.prevent="toggleWaypointNavigator">
      <i class="material-icons">expand_more</i>
    </a>
    <a v-else class="icon-button" v-tooltip.bottom-center="'Hide waypoint\'s time picker'"  href="#" v-on:click.prevent="toggleWaypointNavigator">
      <i class="material-icons">expand_less</i>
    </a>
    <!---->
    <div v-if="showWaypointNavigator">
      <label>Pick time</label>
      <video :src="video.src" :currentTime.prop="value" width="100%" />
      <cling-slider :min="0" :max="videoDuration" :value="value" @input="(time) => onNewTime(time)" v-tooltip.bottom-center="'Set the time with the slider'"></cling-slider>
      <label>Pick a waypoint's time</label>
      <waypoint-navigator :filteredTags="tags" @selectWaypoint="(wp) => onSelectWaypoint(wp)" />
    </div>
    <!---->
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import waypointNavigator from './waypointNavigator'
import timeInput from '../core/timeInput'
import clingSlider from '../core/clingSlider'

export default {
  name: 'timePicker',

  components: {
    'waypoint-navigator': waypointNavigator,
    'time-input': timeInput,
    'cling-slider': clingSlider
  },

  props: {
    tags: {
      type: Array,
      default: () => {
        return []
      }
    },

    value: {
      type: Number,
      default: 0
    },

    controls: {
      type: Object,
      default: () => {
        return {
          start: false,
          end: false
        }
      }
    },

    frameRate: {
      type: Number,
      default: 25
    }
  },

  data: function () {
    return {
      showWaypointNavigator: false
    }
  },

  computed: {
    ...mapState(['video']),
    ...mapGetters(['videoDuration'])
  },

  methods: {
    ...mapMutations(['clearKeyFrame', 'updateKeyFrame']),

    onNewTime: function (time) {
      this.clearKeyFrame()

      this.$emit('newTime', time)
    },

    onStartTime: function () {
      this.clearKeyFrame()

      this.$emit('startTime')
    },

    onEndTime: function () {
      this.clearKeyFrame()

      this.$emit('endTime')
    },

    onSelectWaypoint: function (wp) {
      this.clearKeyFrame()
      this.updateKeyFrame(wp)

      this.$emit('newTime', wp.time)
    },

    toggleWaypointNavigator: function () {
      this.clearKeyFrame()

      this.showWaypointNavigator = !this.showWaypointNavigator
    }
  }
}
</script>
